module.exports = __webpack_public_path__ + "static/media/score.6f95f041.svg";